export default __webpack_public_path__ + "static/media/instagram.0e409af1.svg";